<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>
        <el-input v-model="searchKey" prefix-icon="el-icon-search" placeholder="输入菜品查询" style="width: 250px"></el-input>
        <el-button type="success" @click="queryDataTable">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 120px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            label="餐厅"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span>{{getRestaurantName(scope.row.restaurantid)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="菜品名称"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="总卡路里"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.dish_kcal !== ''">{{scope.row.dish_kcal}} kcal</span>
            </template>
          </el-table-column>
          <el-table-column
            label="营养成分"
            min-width="120"
            align="center">
            <template slot-scope="scope">
              <table border="1" style="border-collapse: collapse;border: #F5F7FA;margin: auto" v-if="scope.row.nutrients !== ''">
                <tr>
                  <td style="padding: 5px 15px"><span>碳水化合物</span></td>
                  <td style="padding: 5px 15px"><span>{{scope.row.nutrients.CHO}}</span></td>
                  <td style="padding: 5px 15px"><span>克</span></td>
                </tr>
                <tr>
                  <td style="padding: 5px 15px"><span>蛋白质</span></td>
                  <td style="padding: 5px 15px"><span>{{scope.row.nutrients.PRO}}</span></td>
                  <td style="padding: 5px 15px"><span>克</span></td>
                </tr>
                <tr>
                  <td style="padding: 5px 15px"><span>脂肪</span></td>
                  <td style="padding: 5px 15px"><span>{{scope.row.nutrients.FAT}}</span></td>
                  <td style="padding: 5px 15px"><span>克</span></td>
                </tr>
                <tr>
                  <td style="padding: 5px 15px"><span>糖类</span></td>
                  <td style="padding: 5px 15px"><span>{{scope.row.nutrients.SUG}}</span></td>
                  <td style="padding: 5px 15px"><span>克</span></td>
                </tr>
                <tr>
                  <td style="padding: 5px"><span>膳食纤维</span></td>
                  <td style="padding: 5px"><span>{{scope.row.nutrients.DF}}</span></td>
                  <td style="padding: 5px 15px"><span>克</span></td>
                </tr>
              </table>
            </template>
          </el-table-column>
          <el-table-column
            label="提供类型"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1">早餐</span>
              <span v-if="scope.row.type === 2">午餐</span>
              <span v-if="scope.row.type === 3">早餐、午餐</span>
              <span v-if="scope.row.type === 4">晚餐</span>
              <span v-if="scope.row.type === 5">早餐、晚餐</span>
              <span v-if="scope.row.type === 6">午餐、晚餐</span>
              <span v-if="scope.row.type === 7">早餐、午餐、晚餐</span>
            </template>
          </el-table-column>
          <el-table-column
            label="图片"
            min-width="90"
            align="center">
            <template slot-scope="scope">
              <img style="height: 100px" v-if="scope.row.picture" :src="baseUrl + 'food/image/' + scope.row.picture + '?token=' + token">
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="价格"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.price}}元</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="desc"
            label="菜品说明"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            label="食材"
            min-width="120"
            align="center">
            <template slot-scope="scope">
<!--              <span v-for="item in scope.row.ingredients" :key="item.index">{{item.name}}，</span>-->
              <el-tag style="margin-left: 5px" v-for="tag in scope.row.ingredients" :key="tag.id" :disable-transitions="false">
<!--                {{tag.name}} / {{tag.val}}{{getUnitName(tag.unitid)}}-->
                {{tag.name}}&nbsp;/&nbsp;
                <span v-if="tag.val === '9999'">不限数量</span>
                <span v-else>{{tag.val}}{{getUnitName(tag.unitid)}}</span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDishes(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-dishes :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-dishes>
    </el-dialog>
  </div>
</template>

<script>
import {queryingredient, queryingredientunit, queryrestaurant, querydish, deletedish} from '../../api/yanglaoyuan'
import {getToken} from '../../utils/auth'

import addEditDishes from './components/addEditDishes'
export default {
  name: 'dishesManagement',
  components: {addEditDishes},
  data () {
    return {
      token: '',
      entityId: 0,
      searchKey: '',
      restaurants: [], // 餐厅
      ingredientunits: [], // 食材单位
      ingredients: [], // 食材
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        restaurants: [], // 餐厅
        ingredientunits: [], // 食材单位
        ingredients: [], // 食材
        isAdd: true,
        row: ''
      },
      // 图片浏览器地址
      baseUrl: ''
    }
  },
  created () {
    this.baseUrl = this.commonType.getapi()
    this.token = getToken()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getRestaurants()
  },
  methods: {
    // 餐厅
    getRestaurants () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.restaurants = res.data.restaurants
        this.addEditObj.restaurants = res.data.restaurants
        this.getunits()
      })
    },
    // 单位
    getunits () {
      queryingredientunit().then(res => {
        this.ingredientunits = res.data.ingredientunits
        this.addEditObj.ingredientunits = res.data.ingredientunits
        this.getIngredients()
      })
    },
    // 食材
    getIngredients () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryingredient(params, data).then(res => {
        this.ingredients = res.data.ingredients
        this.addEditObj.ingredients = res.data.ingredients
        this.queryDataTable()
      })
    },
    queryDataTable () {
      this.tableData = []
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId,
        name: this.searchKey
      }
      querydish(params, data).then(res => {
        let arr = []
        res.data.dishes.forEach(item => {
          item.nutrients = item.dish_nutrients !== '' ? JSON.parse(item.dish_nutrients) : ''
          arr.push(item)
        })
        this.tableData = arr
        this.totalCells = res.data.cnt
      })
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    getUnitName (id) {
      let unitName = ''
      for (let i = 0; i < this.ingredientunits.length; i++) {
        if (id === this.ingredientunits[i].id) {
          unitName = this.ingredientunits[i].name
        }
      }
      return unitName
    },
    getIngredientsName (arr) {
      let name = ''
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < this.ingredients.length; j++) {
          if (arr[i].id === this.ingredients[j].id) {
            name = name === '' ? this.ingredients[j].name : (name + '，' + this.ingredients[j].name)
          }
        }
      }
      return name
    },
    addBtn () {
      this.addEditTitle = '新增菜品'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑菜品'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delDishes (row) {
      this.$confirm('此操作将永久删除该菜品【' + row.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletedish(data).then(res => {
          this.$notify({title: '成功', message: '成功删除菜品', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    updateTable () {
      this.queryDataTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/dishesManagement.vue